<template>
  <v-app>
  <span class="bg"></span>
    <v-main class="dark">
      <JobPage/>
      <!-- <ThankYou/> -->
    </v-main>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
// import ThankYou from './components/ThankYou';
import JobPage from './components/JobPage';

export default {
  name: 'App',

  components: {
    // ThankYou,
    JobPage,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');

html, body {
  font-family: 'Roboto', sans-serif;
}

#app {
  font-family: 'Roboto', sans-serif;
}
.dark {
  color: white;
  font-family: ro;
}
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #090f20;
    background-size: cover;
  }
</style>
